<template>
  <div class="faturas">
    <b-card>
      <b-card-header>
        <b-card-title>Faturas</b-card-title>
      </b-card-header>
      <b-card-body>
        <p class="text-muted">
          Visualize suas faturas e histórico de pagamentos.
        </p>
        <!-- Conteúdo das faturas será implementado aqui -->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'Faturas',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
}
</script>
